import type { Store } from '@/stores';
import { useMapStoreStateToClientState } from '@/hooks/useMapStoreStateToClientState';

// custom hook to read the props
const useStateOfSearchHeader = (store: Store, isRoundTrip: boolean) => {
  return useMapStoreStateToClientState(store, (store: Store) => {
    const pageStore = isRoundTrip
      ? store.appStore.stepByStepSearchPage.currentStepStore
      : store.appStore.completeSearchPage;
    return {
      currenciesList: store.appStore.currency.currenciesList,
      currentCurrency: store.appStore.currency.currentCurrency,
      searchRequest: pageStore.searchResults.searchRequest,
      isMultiCity: store.appStore.completeSearchPage.isMultiCity,
      setCurrentCurrency: store.appStore.currency.setCurrentCurrency,
      currencyStore: store.appStore.currency,
      userStore: store.appStore.user,
    };
  });
};

export default useStateOfSearchHeader;
